"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Dialog = ({
  children,
  header,
  hideCloseButton,
  onClose,
  open
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
  hideCloseButton: hideCloseButton,
  open: open,
  size: "small",
  onClose: onClose,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      fontSize: 22,
      fontWeight: "bold",
      pb: 8,
      pt: 10,
      px: 10,
      variant: "subtitle1",
      children: header
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
      pb: 8,
      children: children
    })]
  })
});
exports.Dialog = Dialog;